import React from "react";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services">

      {/* =============== HERO ================== */}
      <section className="srv-hero">
        <img
          src="https://images.unsplash.com/photo-1554284126-aa88f22d8b74"
          alt="Services Hero"
        />
        <div className="srv-hero-text">
          <h1>OUR SERVICES</h1>
          <p>High-performance coaching built for serious athletes.</p>
        </div>
      </section>


      {/* =============== MINI PILLARS ================== */}
      <section className="srv-pillars">
        <div className="pillar-mini">
          <h2>Strength</h2>
          <p>Powerbuilding cycles designed to increase raw output.</p>
        </div>

        <div className="pillar-mini">
          <h2>Conditioning</h2>
          <p>Intensity-driven systems that enhance stamina and speed.</p>
        </div>

        <div className="pillar-mini">
          <h2>Mobility</h2>
          <p>Movement efficiency and joint-health mastery.</p>
        </div>
      </section>


      {/* =============== SERVICE MODULES (clean layout) ================== */}
      <section className="srv-modules">

        <div className="srv-module">
          <div className="srv-mod-icon">01</div>
          <div className="srv-mod-text">
            <h3>1-on-1 Elite Coaching</h3>
            <p>
              Individualized training plans tailored to biomechanics,
              weaknesses, and performance goals.
            </p>
          </div>
        </div>

        <div className="srv-module">
          <div className="srv-mod-icon">02</div>
          <div className="srv-mod-text">
            <h3>Power Classes</h3>
            <p>
              High-volume athletic sessions focused on explosiveness,
              discipline, and controlled intensity.
            </p>
          </div>
        </div>

        <div className="srv-module">
          <div className="srv-mod-icon">03</div>
          <div className="srv-mod-text">
            <h3>Mobility & Recovery Lab</h3>
            <p>
              Deep-tissue protocols, joint sequencing, and restoration
              pathways designed for longevity.
            </p>
          </div>
        </div>

        <div className="srv-module">
          <div className="srv-mod-icon">04</div>
          <div className="srv-mod-text">
            <h3>Athlete Assessments</h3>
            <p>
              Professional-level evaluations that read movement patterns
              and set performance baselines.
            </p>
          </div>
        </div>

      </section>


      {/* =============== PROCESS STEPS ================== */}
      <section className="srv-process">
        <h2>HOW WE BUILD BETTER ATHLETES</h2>

        <div className="process-grid">
          <div className="process-step">
            <span>01</span>
            <h4>Evaluate</h4>
            <p>Motion, weaknesses, and capacity are deeply analyzed.</p>
          </div>

          <div className="process-step">
            <span>02</span>
            <h4>Program</h4>
            <p>Custom cycles tailored to the athlete’s required output.</p>
          </div>

          <div className="process-step">
            <span>03</span>
            <h4>Execute</h4>
            <p>High-performance coaching during every session.</p>
          </div>

          <div className="process-step">
            <span>04</span>
            <h4>Refine</h4>
            <p>Adjustments made weekly for optimal progression.</p>
          </div>
        </div>
      </section>


      {/* =============== EQUIPMENT STRIP ================== */}
      <section className="srv-strip">
        <div className="strip-img"></div>
        <div className="strip-text">
          <h2>Premium Equipment. Elite Environment.</h2>
          <p>
            Designed for serious athletes who train with purpose.
          </p>
        </div>
      </section>


      {/* =============== CTA ================== */}
      <section className="srv-cta">
        <h1>STEP INTO ELITE TRAINING</h1>
      </section>

    </div>
  );
};

export default Services;
